module.exports = __webpack_public_path__ + "img/tongcheng.3d5ff867.png";